module.exports = function getResource(label) {
    let resources = {
        pleaseUpdateInfoMessage: 'Veuillez mettre vos renseignements à jour'
    };

    return resources[label];
};
